import { render, staticRenderFns } from "./ChangelogModal.vue?vue&type=template&id=9890102c&scoped=true"
import script from "./ChangelogModal.vue?vue&type=script&lang=js"
export * from "./ChangelogModal.vue?vue&type=script&lang=js"
import style0 from "./ChangelogModal.vue?vue&type=style&index=0&id=9890102c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9890102c",
  null
  
)

export default component.exports